/* 契約書署名完了 */
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import Block from '../../molecules/Block';
import Heading from '../../molecules/Heading';
import StepNavigation from '../../molecules/StepNavigation';
import TransitionButton from '../../molecules/TransitionButton';
import { handleBrowserBack } from '../../BrowserBack';

const ContractSignatureComplete: React.FC = () => {
  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
  }, []);

  // マイページへ戻るボタン押下
  const transitionMypage = () => {
    location.replace(`${location.origin}${process.env.MIX_MOCK_URL}/mypage/list`);
  };
  return (
    <>
      <Heading label="契約手続き" size="l" />
      <StepNavigation
        current={3}
        step1="電子契約書確認"
        step2="電子署名ID・KEY\n入力"
        step3="電子署名完了"
        disabled={false}
      />
      <Block
        label="電子署名完了"
        content={
          <>
            <div className="p-lead my-3">
              電子署名を完了しました。
              <br />
              契約者様全員の電子署名が完了しましたらお手続き完了メールをお送りします。お手続き完了メールのご確認をお願いします。
              <br />
              ウィンドウまたはタブを閉じて下さい。
            </div>
            <TransitionButton
              label="マイページへ戻る"
              btn_class="two_lines"
              handleClick={transitionMypage}
            />
          </>
        }
      />
    </>
  );
};

if (document.getElementById('contract-signature-complete')) {
  ReactDOM.render(
    <ContractSignatureComplete />,
    document.getElementById('contract-signature-complete')
  );
}
